import axios from 'axios'

console.log(process.env);
const manufacturingApi = axios.create({
    baseURL: process.env.VUE_APP_WEBAPP_API_URL
})

export default manufacturingApi